import { render, staticRenderFns } from "./HistoricoConsulta.vue?vue&type=template&id=c7d23828&"
import script from "./HistoricoConsulta.vue?vue&type=script&lang=js&"
export * from "./HistoricoConsulta.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoConsulta.vue?vue&type=style&index=0&id=c7d23828&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports